import { render, staticRenderFns } from "./customPaginationTable.vue?vue&type=template&id=898a2a68&scoped=true"
import script from "./customPaginationTable.vue?vue&type=script&lang=js"
export * from "./customPaginationTable.vue?vue&type=script&lang=js"
import style0 from "./customPaginationTable.vue?vue&type=style&index=0&id=898a2a68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898a2a68",
  null
  
)

export default component.exports